import { setSearchTerm } from "../usersDataReducer";
import { useSearch } from "../../../../core/util/storeHooks";

export const useUserSearch = () => useSearch(s => s.data.listing.users.searchTerm, setSearchTerm);
